import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=4bd8e328&"
import script from "./UsersList.vue?vue&type=script&lang=js&"
export * from "./UsersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd8e328')) {
      api.createRecord('4bd8e328', component.options)
    } else {
      api.reload('4bd8e328', component.options)
    }
    module.hot.accept("./UsersList.vue?vue&type=template&id=4bd8e328&", function () {
      api.rerender('4bd8e328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/61221000-4/components/UsersList.vue"
export default component.exports